import { render } from "./SubstabelecimentoComponent.vue?vue&type=template&id=0d5dcc9a&scoped=true"
import script from "./SubstabelecimentoComponent.vue?vue&type=script&lang=js"
export * from "./SubstabelecimentoComponent.vue?vue&type=script&lang=js"

import "./SubstabelecimentoComponent.vue?vue&type=style&index=0&id=0d5dcc9a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5dcc9a"]])

export default __exports__